import React from 'react';
export function ProblemSection() {
  return <section className="py-8 px-4 bg-gray-50" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#F9327E]" data-id="element-105">
          NO TODOS LOS ESTUDIANTES APRENDEN DE LA MISMA MANERA
        </h2>

        <p className="text-lg mb-5 text-center text-gray-700" data-id="element-106">
          Los materiales tradicionales suelen ser extensos, confusos y poco
          accesibles para muchos alumnos.
        </p>

        <p className="text-base md:text-lg text-center font-bold text-gray-800 mb-4" data-id="element-107">
          Pensado para acompañar estudiantes con:
        </p>

        <div className="flex flex-wrap justify-center gap-2 max-w-2xl mx-auto" data-id="element-108">
          {['TDAH', 'TEA', 'Dislexia', 'Dificultades de aprendizaje', 'Distintos ritmos de aprendizaje'].map(item => <span key={item} className="bg-white border-2 border-[#3CD0E4] text-gray-900 font-bold px-4 py-1.5 rounded-full text-sm md:text-base shadow-sm" data-id="element-109">
              ✔ {item}
            </span>)}
        </div>
      </div>
    </section>;
}